import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../assets/logo-256.png';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="ebw-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-3">
            <Link to="/">
              <img src={logoImg} alt="eBuyWiz" style={{ height: '38px', width: 'auto', marginBottom: '8px' }} />
            </Link>
            <p className="small mb-0 opacity-75">{t('footerDesc')}</p>
          </div>
          <div className="col-lg-2 col-md-3 col-6 mb-3">
            <h6 className="fw-bold mb-2">{t('shop')}</h6>
            <ul className="list-unstyled mb-0">
              <li className="mb-1"><Link to="/products">{t('allProducts')}</Link></li>
              <li className="mb-1"><Link to="/stores">{t('stores')}</Link></li>
              <li className="mb-1"><Link to="/flash-deals">{t('deals')}</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-6 mb-3">
            <h6 className="fw-bold mb-2">{t('sell')}</h6>
            <ul className="list-unstyled mb-0">
              <li className="mb-1"><Link to="/register?role=merchant">{t('becomeSeller')}</Link></li>
              <li className="mb-1"><Link to="/merchant/dashboard">{t('sellerDashboard')}</Link></li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-6 mb-3">
            <h6 className="fw-bold mb-2">{t('support')}</h6>
            <ul className="list-unstyled mb-0">
              <li className="mb-1"><Link to="/help">{t('helpCenter')}</Link></li>
              <li className="mb-1"><Link to="/contact">{t('contactUs')}</Link></li>
              <li className="mb-1"><Link to="/privacy">{t('privacyPolicy')}</Link></li>
              <li className="mb-1"><Link to="/terms">{t('termsOfService')}</Link></li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-3 col-6 mb-3">
            <h6 className="fw-bold mb-2">{t('newsletter')}</h6>
            <p className="small opacity-75 mb-2" style={{ fontSize: '12px' }}>{t('newsletterDesc')}</p>
            <form onSubmit={async (e) => {
              e.preventDefault();
              const email = e.target.email.value;
              try {
                const res = await fetch(`${import.meta.env.VITE_API_URL || ''}/v1/newsletter/subscribe`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ email }),
                });
                const data = await res.json();
                e.target.email.value = '';
                alert(data.message || 'Subscribed!');
              } catch { alert('Please try again later.'); }
            }}>
              <div className="input-group input-group-sm">
                <input name="email" type="email" className="form-control" placeholder={t('yourEmail')} required style={{ borderColor: '#374151', fontSize: '12px' }} />
                <button className="btn" type="submit" style={{ background: '#B91C1C', color: '#fff', border: 'none', fontSize: '12px' }}>{t('subscribe')}</button>
              </div>
            </form>
          </div>
        </div>
        <div className="footer-bottom text-center pt-2 mt-2">
          <p className="mb-0 small">&copy; {new Date().getFullYear()} eBuyWiz. {t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
